document.addEventListener('DOMContentLoaded', () => {
  const list = document.querySelector('[data-news-list]');
  const filter = document.querySelector('[data-news-filter]');
  const emptyState = document.querySelector('[data-news-empty]');

  if (!list || !filter) return;

  const items = Array.from(list.querySelectorAll('[data-news-item]'));
  const searchParams = new URLSearchParams(window.location.search);
  const initialFilter = searchParams.get('category');

  if (initialFilter) {
    filter.value = initialFilter;
  }

  const syncLayout = (visibleItems) => {
    visibleItems.forEach((item, index) => {
      item.classList.remove('is-odd', 'is-even');
      if (index % 2 === 0) {
        item.classList.add('is-odd');
      } else {
        item.classList.add('is-even');
      }
    });
  };

  const applyFilter = () => {
    const selected = filter.value || 'all';
    const visibleItems = [];

    items.forEach((item) => {
      const matches = selected === 'all' || item.dataset.newsCategory === selected;
      item.style.display = matches ? 'flex' : 'none';

      if (matches) {
        visibleItems.push(item);
      }
    });

    syncLayout(visibleItems);

    if (emptyState) {
      emptyState.hidden = visibleItems.length > 0;
    }

    const nextUrl = new URL(window.location.href);

    if (selected === 'all') {
      nextUrl.searchParams.delete('category');
    } else {
      nextUrl.searchParams.set('category', selected);
    }

    window.history.replaceState({}, '', nextUrl);
  };

  filter.addEventListener('change', applyFilter);
  applyFilter();
});
